import React, { useState } from 'react';
import './GeneralSettings.css';
import '../../components/Button/Button.css';
import { useLanguage } from '../../context/LanguageContext';
import { getTranslation } from '../../i18n/translations';

const GeneralSettings = () => {
  const { language } = useLanguage();
  const [email, setEmail] = useState('user@example.com');
  const [phone, setPhone] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [promocode, setPromocode] = useState('');
  const [emailVerified, setEmailVerified] = useState(true);
  const [phoneVerified, setPhoneVerified] = useState(false);
  const [saved, setSaved] = useState(false);
  const [sending, setSending] = useState(false);

  const handleSaveChanges = () => {
    // Simulate save
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  const handleVerifyEmail = () => {
    // Simulate email verification
    console.log('Verifying email:', email);
    // In real app, this would trigger email verification flow
  };

  const handleVerifyPhone = () => {
    // Simulate phone verification
    console.log('Verifying phone:', phone);
    // In real app, this would trigger phone verification flow
  };

  const handleSendPromocode = () => {
    if (promocode.trim()) {
      setSending(true);
      // Simulate sending
      setTimeout(() => {
        setSending(false);
        setPromocode('');
        alert('Promocode sent successfully!');
      }, 1000);
    }
  };

  const handleActivityHistory = () => {
    // Navigate to activity history page
    console.log('Navigate to Activity History');
  };

  const handle2FASettings = () => {
    // Navigate to 2FA settings page
    console.log('Navigate to 2FA Settings');
  };

  const handleChangePassword = () => {
    // Navigate to change password page
    console.log('Navigate to Change Password');
  };

  return (
    <div className="setting-container">
      <div className="setting"> 
        <div className="setting__block">
          <div className="container-settings-general">
            <div className="setting-general-block__block">
              <div className="setting-general-block__input-check">
                {/* Change Email */}
                <div className="setting-general-block__input-block">
                  <div className={`ui-input setting-general-block__input ${emailVerified ? 'disabled' : ''}`}>
                    <div className="ui-input-group">
                      <input
                        className="ui-input__block"
                        type="email"
                        placeholder=""
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={emailVerified}
                      />
                      <p className="error-text"></p>
                      <p className="success-text"></p>
                    </div>
                    <div>
                      <div className="ui-input__text-block">
                        <button
                          className="gray ui-input__text"
                          type="button"
                          onClick={handleVerifyEmail}
                          disabled={emailVerified}
                        >
                          {getTranslation('verify', language)}
                        </button>
                        {emailVerified && (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            alt="Verified"
                            className="ui-input__img"
                          >
                            <g clipPath="url(#clip0_6396_3441)">
                              <path
                                d="M5.00016 7.99992L7.00016 9.99992L11.0002 5.99992M14.6668 7.99992C14.6668 11.6818 11.6821 14.6666 8.00016 14.6666C4.31826 14.6666 1.3335 11.6818 1.3335 7.99992C1.3335 4.31802 4.31826 1.33325 8.00016 1.33325C11.6821 1.33325 14.6668 4.31802 14.6668 7.99992Z"
                                stroke="#1570EF"
                                strokeWidth="1.6"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                            </g>
                            <defs>
                              <clipPath id="clip0_6396_3441">
                                <rect width="16" height="16" fill="white"></rect>
                              </clipPath>
                            </defs>
                          </svg>
                        )}
                      </div>
                    </div>
                  </div>
                  <p className="setting-general-block__input-title">{getTranslation('changeEmail', language)}</p>
                </div>

                {/* Change Phone */}
                <div className="setting-general-block__input-block">
                  <div className="ui-input setting-general-block__input">
                    <div className="ui-input-group">
                      <input
                        className="ui-input__block"
                        type="tel"
                        placeholder=""
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                      />
                      <p className="error-text"></p>
                      <p className="success-text"></p>
                    </div>
                    <div>
                      <div className="ui-input__text-block">
                        <button
                          className="gray ui-input__text"
                          type="button"
                          onClick={handleVerifyPhone}
                        >
                          {getTranslation('verify', language)}
                        </button>
                        {!phoneVerified && (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            alt="Not Verified"
                            className="ui-input__img"
                          >
                            <g clipPath="url(#clip0_6396_2937)">
                              <path
                                d="M6.05992 6.00004C6.21665 5.55449 6.52602 5.17878 6.93322 4.93946C7.34042 4.70015 7.81918 4.61267 8.2847 4.69252C8.75022 4.77236 9.17246 5.01439 9.47664 5.37573C9.78081 5.73706 9.94729 6.19439 9.94659 6.66671C9.94659 8.00004 7.94659 8.66671 7.94659 8.66671M7.99992 11.3334H8.00659M14.6666 8.00004C14.6666 11.6819 11.6818 14.6667 7.99992 14.6667C4.31802 14.6667 1.33325 11.6819 1.33325 8.00004C1.33325 4.31814 4.31802 1.33337 7.99992 1.33337C11.6818 1.33337 14.6666 4.31814 14.6666 8.00004Z"
                                stroke="#98A2B3"
                                strokeWidth="1.33333"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                            </g>
                            <defs>
                              <clipPath id="clip0_6396_2937">
                                <rect width="16" height="16" fill="white"></rect>
                              </clipPath>
                            </defs>
                          </svg>
                        )}
                      </div>
                    </div>
                  </div>
                  <p className="setting-general-block__input-title">{getTranslation('changePhone', language)}</p>
                </div>

                {/* First Name */}
                <div className="setting-general-block__input-block">
                  <div className="ui-input setting-general-block__input">
                    <div className="ui-input-group">
                      <input
                        className="ui-input__block"
                        type="text"
                        placeholder=""
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                      />
                      <p className="error-text"></p>
                      <p className="success-text"></p>
                    </div>
                  </div>
                  <p className="setting-general-block__input-title">{getTranslation('firstName', language)}</p>
                </div>

                {/* Last Name */}
                <div className="setting-general-block__input-block">
                  <div className=" ">
                    <div className="ui-input-group">
                      <input
                        className="ui-input__block"
                        type="text"
                        placeholder=""
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                      />
                      <p className="error-text"></p>
                      <p className="success-text"></p>
                    </div>
                  </div>
                  <p className="setting-general-block__input-title">{getTranslation('lastName', language)}</p>
                </div>
              </div>
              <button
                className="orange setting-general-block__btn"
                type="button"
                onClick={handleSaveChanges}
              >
                {getTranslation('saveChanges', language)}
              </button>
              {saved && (
                <p className="message" style={{ color: 'green', fontSize: '12px', marginTop: '8px' }}>
                  Changes saved successfully!
                </p>
              )}
            </div>

            {/* Promocode Block */}
            <div className="setting-general-block__promo-block">
              <div className="setting-general-block__promo-message">
                <div className="ui-input setting-general-block__promo">
                  <div className="ui-input-group">
                    <input
                      className="ui-input__block"
                      type="text"
                      placeholder={getTranslation('promocode', language)}
                      value={promocode}
                      onChange={(e) => setPromocode(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter' && promocode.trim()) {
                          handleSendPromocode();
                        }
                      }}
                    />
                    <p className="error-text"></p>
                    <p className="success-text"></p>
                  </div>
                </div>
              </div>
              <button
                className="primary"
                type="button"
                onClick={handleSendPromocode}
                disabled={!promocode.trim() || sending}
                style={{ cursor: promocode.trim() && !sending ? 'pointer' : 'not-allowed', opacity: promocode.trim() && !sending ? 1 : 0.5 }}
              >
                {sending ? getTranslation('loading', language) : getTranslation('send', language)}
              </button>
            </div>
          </div>
        </div>

        {/* Additional Settings Blocks */}
        <div className="setting-block__ui">
          <div className="ui-setting-block" onClick={handleActivityHistory} style={{ cursor: 'pointer' }}>
            <div style={{ width: '36px', height: '36px' }}>
              <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18 11.25V18"
                  stroke="#D0D5DD"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
                <path
                  d="M23.85 21.375L18 18"
                  stroke="#D0D5DD"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
                <path
                  d="M25.9031 14.0204H31.5281V8.39539"
                  stroke="#D0D5DD"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
                <path
                  d="M26.7469 26.7469C25.0167 28.4786 22.8117 29.6582 20.4109 30.1365C18.0101 30.6148 15.5214 30.3703 13.2595 29.434C10.9977 28.4976 9.06441 26.9115 7.70418 24.8762C6.34396 22.841 5.61792 20.448 5.61792 18C5.61792 15.552 6.34396 13.1591 7.70418 11.1238C9.06441 9.0885 10.9977 7.50237 13.2595 6.56603C15.5214 5.62969 18.0101 5.38522 20.4109 5.86353C22.8117 6.34184 25.0167 7.52145 26.7469 9.25313L31.5282 14.0203"
                  stroke="#D0D5DD"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </div>
            <p className="ui-setting-block__title">{getTranslation('activityHistory', language)}</p>
          </div>

          <div className="ui-setting-block" onClick={handle2FASettings} style={{ cursor: 'pointer' }}>
            <div style={{ width: '36px', height: '36px' }}>
              <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18 24.75C21.7279 24.75 24.75 21.7279 24.75 18C24.75 14.2721 21.7279 11.25 18 11.25C14.2721 11.25 11.25 14.2721 11.25 18C11.25 21.7279 14.2721 24.75 18 24.75Z"
                  stroke="#D0D5DD"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
                <path
                  d="M25.8329 9.15479C26.1892 9.48291 26.5267 9.82041 26.8454 10.1673L30.6845 10.7157C31.31 11.8021 31.7921 12.9649 32.1188 14.1751L29.7845 17.2829C29.7845 17.2829 29.8267 18.2392 29.7845 18.7173L32.1188 21.8251C31.7936 23.0358 31.3114 24.1988 30.6845 25.2845L26.8454 25.8329C26.8454 25.8329 26.1845 26.522 25.8329 26.8454L25.2845 30.6845C24.1981 31.31 23.0353 31.7921 21.8251 32.1188L18.7173 29.7845C18.2401 29.8267 17.7601 29.8267 17.2829 29.7845L14.1751 32.1188C12.9643 31.7936 11.8014 31.3114 10.7157 30.6845L10.1673 26.8454C9.82041 26.5173 9.48291 26.1798 9.15479 25.8329L5.31572 25.2845C4.6902 24.1981 4.20806 23.0353 3.88135 21.8251L6.21572 18.7173C6.21572 18.7173 6.17354 17.761 6.21572 17.2829L3.88135 14.1751C4.20655 12.9643 4.68876 11.8014 5.31572 10.7157L9.15479 10.1673C9.48291 9.82041 9.82041 9.48291 10.1673 9.15479L10.7157 5.31572C11.8021 4.6902 12.9649 4.20806 14.1751 3.88135L17.2829 6.21572C17.7601 6.17353 18.2401 6.17353 18.7173 6.21572L21.8251 3.88135C23.0358 4.20655 24.1988 4.68876 25.2845 5.31572L25.8329 9.15479Z"
                  stroke="#D0D5DD"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </div>
            <p className="ui-setting-block__title">{getTranslation('twoFASettings', language)}</p>
          </div>

          <div className="ui-setting-block" onClick={handleChangePassword} style={{ cursor: 'pointer' }}>
            <div style={{ width: '36px', height: '36px' }}>
              <svg
                width="36px"
                height="36px"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
              >
                <title>Iconly/Two-tone/Password</title>
                <g id="Iconly/Two-tone/Password" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                  <g id="Password" transform="translate(2.000000, 2.000000)" stroke="#D0D5DD" strokeWidth="1.5">
                    <path
                      id="Stroke-1"
                      d="M14.3344,0.7502 L5.6654,0.7502 C2.6444,0.7502 0.7504,2.8892 0.7504,5.9162 L0.7504,14.0842 C0.7504,17.1112 2.6354,19.2502 5.6654,19.2502 L14.3334,19.2502 C17.3644,19.2502 19.2504,17.1112 19.2504,14.0842 L19.2504,5.9162 C19.2504,2.8892 17.3644,0.7502 14.3344,0.7502 Z"
                      opacity="0.400000006"
                    ></path>
                    <path
                      id="Stroke-3"
                      d="M8.6923,10.0002 C8.6923,11.0222 7.8633,11.8522 6.8403,11.8522 C5.8183,11.8522 4.9893,11.0222 4.9893,10.0002 C4.9893,8.9782 5.8183,8.1482 6.8403,8.1482 C7.8633,8.1482 8.6923,8.9782 8.6923,10.0002 Z"
                    ></path>
                    <polyline id="Stroke-5" points="8.6923 10.0002 15.0103 10.0002 15.0103 11.8522"></polyline>
                    <line id="Stroke-7" x1="12.1816" y1="11.8517" x2="12.1816" y2="9.9997"></line>
                  </g>
                </g>
              </svg>
            </div>
            <p className="ui-setting-block__title">{getTranslation('changePassword', language)}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralSettings;

